// extracted by mini-css-extract-plugin
export default {"root":"styles_root__BbuF9","header":"styles_header__rhfvB","add-button":"styles_add-button__yWPB8","contacts-note-search":"styles_contacts-note-search__zLXm9"};